// Versus arenas (same legend as rooms.ts). Mirror-symmetric so neither side has an edge:
// two P markers (side 0 spawns on the left one, side 1 on the right), 'a' / 'g' markers are
// the surprise-drop spots, solid edges everywhere (no doors), cover blocks are destructible.
// Climbs rise ≤ 4 tiles (BASTION's single + double jump budget, see rooms.ts).

import type { RoomTemplate } from './rooms';

function grid(src: string): string[] {
  return src
    .split('\n')
    .map((l) => l.trim())
    .filter((l) => l.length > 0);
}

export const ARENAS: RoomTemplate[] = [
  {
    id: 'arena_crossfire',
    type: 'start',
    name: 'CROSSFIRE',
    tiles: grid(`
      ########################################
      #......................................#
      #......................................#
      #.................a..a.................#
      #..............==========..............#
      #......................................#
      #......a........................a......#
      #.................g..g.................#
      #...=======.....########.....=======...#
      #......................................#
      #......................................#
      #..a................................a..#
      #........======..........======........#
      #......................................#
      #...............##....##...............#
      #..P.......g....##....##....g.......P..#
      ########################################
      ########################################
    `),
  },
  {
    id: 'arena_scrapyard',
    type: 'start',
    name: 'SCRAPYARD',
    tiles: grid(`
      ########################################
      #......................................#
      #......................................#
      #........a....................a........#
      #......................................#
      #................a....a................#
      #.....========............========.....#
      #......................................#
      #......................................#
      #..............==========..............#
      #...a..............................a...#
      #......................................#
      #.......g......................g.......#
      #.....#####..................#####.....#
      #.....#####..................#####.....#
      #.P...#####........gg........#####...P.#
      ########################################
      ########################################
    `),
  },
];
